function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import isNumber from 'lodash/isNumber';
import isUndefined from 'lodash/isUndefined';
import LightningBoltIcon from '@signal/components/Icons/LightningBolt';
import HydrateSvgIcon from '@signal/components/Icons/utils/hydrateSvg';
import isRelativeUrl from '@signal/utils/isRelativeUrl';
import stripQueryParams from '@signal/utils/stripQueryParams';
import { RENDER_AS_BOTH, RENDER_AS_HEADER, RENDER_AS_MENU } from './constants';
export var APPS_BASE_URL = 'https://apps.purecars.com';
var PRIMARY_DOMAIN_SEGMENT_REGEX = /\/\/([^./]+)\./;

function renderAsMenu(renderAs) {
  return !renderAs || // no renderAs specified assumes menu
  renderAs === RENDER_AS_MENU || renderAs === RENDER_AS_BOTH;
}
/**
 * this function hydrates an icon string, which should be a parseable <svg>, into an actual Signal SVG component
 * @param {Object} - properties that should be applied to the HydrateSvgIcon, including the svgString
 * @return {React.Component} - a Signal SVG component for this icon, or undefined if no icon string was provided
 */


function hydrateServiceMenuIcon(_ref) {
  var svgString = _ref.svgString,
      rest = _objectWithoutProperties(_ref, ["svgString"]);

  var MenuIcon = function MenuIcon() {
    return /*#__PURE__*/React.createElement(HydrateSvgIcon, Object.assign({
      svgString: svgString,
      ErrorIcon: LightningBoltIcon
    }, rest));
  };

  return svgString ? /*#__PURE__*/memo(MenuIcon) : undefined;
}
/**
 * this function hydrates all the icons in a service menu returned from the service
 * @param {Array} rawMenu - the array of menu items returned from useMenuService
 * @param {Object} iconProps - properties that should be applied to the HydrateSvgIcon for colorization/size purposes
 * @param {String} baseUrl - the base URL to use
 * @return {Array} - the hydrated array of menu items returned from useMenuService
 */


export function hydrateServiceMenuIcons(rawMenu, iconProps) {
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : APPS_BASE_URL;
  var baseUrlQA; // attempt to extract the "primary domain" (e.g. "primary" in https://primary.purecars.com/)

  var primaryDomainMatches = baseUrl.match(PRIMARY_DOMAIN_SEGMENT_REGEX);

  if (primaryDomainMatches.length > 1) {
    // use it to get a QA domain to compare against for
    var primaryDomain = primaryDomainMatches[1];
    baseUrlQA = baseUrl.replace(primaryDomainMatches[0], "//".concat(primaryDomain, "-qa."));
  }

  return rawMenu.map(function (_ref2) {
    var children = _ref2.children,
        icon = _ref2.icon,
        link = _ref2.link,
        rest = _objectWithoutProperties(_ref2, ["children", "icon", "link"]);

    if (link) {
      // also make any base URL relative
      if (link.startsWith(baseUrl)) {
        link = link.substr(baseUrl.length);
      } else if (baseUrlQA && link.startsWith(baseUrlQA)) {
        link = link.substr(baseUrlQA.length);
      }
    }

    return _objectSpread(_objectSpread({}, rest), {}, {
      link: link,
      icon: hydrateServiceMenuIcon(_objectSpread({
        svgString: icon
      }, iconProps)),
      children: children ? hydrateServiceMenuIcons(children, iconProps, baseUrl) : []
    });
  });
}
/**
 * this function filters the given service menu for items that should be rendered in the multi-app-menu (popover)
 * @param {Array} serviceMenu - the array of menu items returned from useMenuService or any subset thereof
 * @return {Array} - the array of menu items that should be rendered in the header
 */

export function filterServiceMenuItemsForPopover(serviceMenu) {
  return serviceMenu.filter(function (_ref3) {
    var renderAs = _ref3.renderAs;
    return renderAsMenu(renderAs);
  }).map(function (_ref4) {
    var children = _ref4.children,
        rest = _objectWithoutProperties(_ref4, ["children"]);

    return _objectSpread(_objectSpread({}, rest), {}, {
      subMenuItems: children ? filterServiceMenuItemsForPopover(children) : []
    });
  });
}
/**
 * this function returns the default menu service items and index to use in the event no match can be found to the
 * current user's URL in the menu service response
 * @param {Array} serviceMenu - the array of menu items returned from useMenuService
 * @return {Object} - an object that returns the default menu service item and index
 */

export function findDefaultMenuServiceIndexAndItems() {
  var serviceMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filteredMenu = filterServiceMenuItemsForPopover(serviceMenu);

  var findDefault = function findDefault(items, rootIndex) {
    return items.reduce(function (found, _ref5, itemIndex) {
      var link = _ref5.link,
          subMenuItems = _ref5.subMenuItems;

      if (found) {
        return found;
      }

      if (link && isRelativeUrl(link)) {
        if (!isUndefined(rootIndex)) {
          // we found a usable link in a submenu.  Use this submenu/root index
          return {
            items: items,
            rootIndex: rootIndex
          };
        } else if (!subMenuItems) {
          // we found a usable link in a root menu item without submenu children.  Use this root index with no submenu
          return {
            items: [],
            rootIndex: itemIndex
          };
        }
      }

      return subMenuItems ? findDefault(subMenuItems, isUndefined(rootIndex) ? itemIndex : rootIndex) : null;
    }, null);
  }; // if unable to find a matching domain after searching, then use just the first thing in the menu.


  return findDefault(filteredMenu) || {
    items: filteredMenu.length ? filteredMenu[0].subMenuItems : [],
    rootIndex: filteredMenu.length ? 0 : undefined
  };
}
/**
 * this function attempts to find all the menu items with a given renderAs at the given pathname
 * @param {Array} serviceMenu - the array of menu items returned from useMenuService
 * @param {String} pathname - the pathname whose header nav destinations should be found
 * @param {String} renderAsMatch - one of the renderAs types to find (header, select)
 * @return {Array} - the array of menu items that should be rendered at the header at this pathname
 */

export function findMenuRenderAsAtPath(serviceMenu, pathname) {
  var renderAsMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RENDER_AS_HEADER; // this variable will be set inside the recursive algorithm below once the menu items we want to return are found

  var menuItemsFound = [];

  var filterFoundItems = function filterFoundItems(foundItems) {
    return foundItems.filter(function (_ref6) {
      var renderAs = _ref6.renderAs;
      return renderAs === renderAsMatch;
    });
  }; // use a recursive find to find the first destination that matches the given pathname
  // once we find that destination, we look backwards through the ancestors to find the nearest ancestor which has
  // matching menu items of the renderAs type we are looking for


  var findMatchingPath = function findMatchingPath(menuItems, ancestorMenuItems) {
    return menuItems.find(function (elem) {
      var children = elem.children,
          link = elem.link;

      if (pathname.endsWith(link)) {
        ancestorMenuItems = [menuItems].concat(_toConsumableArray(ancestorMenuItems));

        if (children) {
          // also check any children to see if there is a match there too.  if so, we want to use the children not the
          // parent (since it might be a rollup parent).  If a match is found in the child menuItemsFound will be set
          // to the children by the child call
          if (findMatchingPath(children, ancestorMenuItems)) {
            return true;
          }
        } // look at all ancestors menu sets, nearest first, and bail when we find the first ancestor menu list which has
        // at least one menu item with a renderAs type that we are looking for
        // this allows us to support cases where the header entries are defined further up the hierarchy than selects


        ancestorMenuItems.find(function (menuItems) {
          var foundItems = filterFoundItems(menuItems);

          if (foundItems.length) {
            menuItemsFound = foundItems;
            return true;
          }

          return false;
        });
        return true;
      }

      return children && findMatchingPath(children, [menuItems].concat(_toConsumableArray(ancestorMenuItems)));
    });
  }; // kick off the recursion starting at the base of service menu, no ancestors yet


  findMatchingPath(serviceMenu, []);

  if (!menuItemsFound.length && renderAsMenu(renderAsMatch)) {
    return findDefaultMenuServiceIndexAndItems(serviceMenu).items;
  }

  return menuItemsFound;
}
/**
 * this function returns the index of the root item in the service menu related to the given path.  This is useful to
 * determine which menu item should be selected at the root of the menu in the new menu design
 * @param {Array} serviceMenu - the array of menu items returned from useMenuService
 * @param {String} pathname - the pathname where the app is currently navigated to
 * @param {Boolean} noExact - don't require an exact URL match
 * @return {Number} - the index of the element in the serviceMenu which contains the location currently navigated to
 */

export function findActiveServiceMenuRootItemIndex(serviceMenu, pathname) {
  var noExact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // this variable will be set inside the recursive algorithm below once the menu items we want to return are found

  var rootElemIndexFound; // use a recursive find to find the first destination that matches the given pathname

  var findMatchingPath = function findMatchingPath(menuItems, rootElemIndex) {
    return menuItems.find(function (elem, elemIndex) {
      var children = elem.children,
          link = elem.link;

      if (link && (noExact ? pathname.startsWith(stripQueryParams(link)) : pathname === stripQueryParams(link))) {
        rootElemIndexFound = isNumber(rootElemIndex) ? rootElemIndex : elemIndex;
        return elem;
      }

      return children && findMatchingPath(children, isNumber(rootElemIndex) ? rootElemIndex : elemIndex);
    });
  }; // kick off the recursion starting at the base of service menu, no ancestors yet


  findMatchingPath(serviceMenu);

  if (isUndefined(rootElemIndexFound)) {
    return noExact ? findDefaultMenuServiceIndexAndItems(serviceMenu).rootIndex : findActiveServiceMenuRootItemIndex(serviceMenu, pathname, true
    /*noExact*/
    );
  }

  return rootElemIndexFound;
}
/**
 * this function returns a redirect URL obtained from the menuService.  It is defined as the first internal or PureCars
 * route returned from the menu service.
 * @param {Array} serviceMenu - the array of menu items returned from useMenuService
 * @param {Boolean} allowDifferentDomain - whether to allow redirection to a different domain than the local domain
 * @return {String} - the redirect URL to use, or null if no suitable redirect URL can be obtained
 */

export function getDefaultRedirect() {
  var serviceMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowDifferentDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var filteredMenu = filterServiceMenuItemsForPopover(serviceMenu);

  var findRedirect = function findRedirect(items) {
    return items.reduce(function (found, _ref7) {
      var link = _ref7.link,
          subMenuItems = _ref7.subMenuItems;

      if (found) {
        return found;
      }

      if (link && (allowDifferentDomain || isRelativeUrl(link))) {
        return link;
      }

      return subMenuItems ? findRedirect(subMenuItems) : null;
    }, null);
  };

  return findRedirect(filteredMenu) || APPS_BASE_URL;
}